import * as React from 'react';
import { UIHeading3 } from '@cian/ui-kit';

import { Divider } from '../../Divider';

import * as styles from './FieldRowGroupTitle.css';

interface IFieldRowGroupTitleProps {
  title: React.ReactNode;
}

export const FieldRowGroupTitle: React.FC<IFieldRowGroupTitleProps> = ({ title }) => (
  <div className={styles['container']}>
    <div className={styles['heading-wrapper']}>
      <UIHeading3>{title}</UIHeading3>
    </div>
    <Divider />
  </div>
);
